export default "__VITE_ASSET__CA8NR28v__"